import React from "react";
import "../styles/testconsole.css";

const isMobile = window.innerWidth <= 768;

const MiddleTestConsole = ({
  questions,
  curQues,
  nextQues,
  preQues,
  clearResponse,
  setAnswer,
  ansArray,
  mobile=false
}) => {
  const q = questions[curQues];

  return (
    <div className="mc-wrap">
      <div className="mc-question">
        <div className="mc-qleft">{curQues + 1}.</div>
        <div className="mc-qtext" id="ques-heading">
          <span className="questionpre">{q.Question}</span>
        </div>
      </div>

      {q.Image1 && (
        <div className="mc-image">
          <img
            src={`https://epolylearning.com/QuestionImages/${q.QuestionId}-1.png`}
            alt=""
          />
        </div>
      )}
      {q.Image2 && (
        <div className="mc-image">
          <img
            src={`https://epolylearning.com/QuestionImages/${q.QuestionId}-2.png`}
            alt=""
          />
        </div>
      )}

      <div className="mc-options">
        <label className="mc-option row-stripped">
          <input
            type="radio"
            className="ans-radio"
            id="optiona"
            value={q.Option1}
            name="selected_ans"
            onClick={(e) => setAnswer(e.target.value)}
          />
          <span className="mc-option-text">{q.Option1}</span>
        </label>

        <label className="mc-option">
          <input
            type="radio"
            className="ans-radio"
            id="optionb"
            value={q.Option2}
            name="selected_ans"
            onClick={(e) => setAnswer(e.target.value)}
          />
          <span className="mc-option-text">{q.Option2}</span>
        </label>

        <label className="mc-option row-stripped">
          <input
            type="radio"
            className="ans-radio"
            id="optionc"
            value={q.Option3}
            name="selected_ans"
            onClick={(e) => setAnswer(e.target.value)}
          />
          <span className="mc-option-text">{q.Option3}</span>
        </label>

        <label className="mc-option">
          <input
            type="radio"
            className="ans-radio"
            id="optiond"
            value={q.Option4}
            name="selected_ans"
            onClick={(e) => setAnswer(e.target.value)}
          />
          <span className="mc-option-text">{q.Option4}</span>
        </label>

         {q.Option5 &&(<label className="mc-option row-stripped">
          <input
            type="radio"
            className="ans-radio"
            id="optione"
            value={q.Option5}
            name="selected_ans"
            onClick={(e) => setAnswer(e.target.value)}
          />
          <span className="mc-option-text">{q.Option5}</span>
        </label>)}

      </div>

{!isMobile && (
      <div className="mc-actions">
        <button className="ghost-btn" onClick={preQues}>
          Prev
        </button>
        <button className="nxt-btn" onClick={nextQues}>
          Next
        </button>
        <button className="warn-btn" onClick={clearResponse}>
          Clear Response
        </button>
      </div>
      )}
    </div>
  );
};

export default MiddleTestConsole;
